/**
 * Handler for retrieving GPP data from the logged-in user
 *
 * Privacy team docs: https://kb.tech.viacomcbsprivacy.com/technical-specifications/gpp-spec/#web-implementation
 *
 * @param { CBSOptanonCMP } instance
 * @returns {
 *   getGPPData: {
 *       gpp_sid: GPPIDString,
 *       gpp: GPPString
 *   }
 * }
 *
 * Use:
 *  OptanonGPP(CBSOptanonCMP).getGPPData().then( consents => console.info(consents) ) // {
 *      gpp_sid: GPPIDString,
 *      gpp: GPPString
 *  }
 */

export function OptanonGPP(instance) {
    const optanonCMP = instance;
    const getGPPData = () => {
        return new Promise((resolve) => {
            optanonCMP.gpp.send('ping', async (data) => {
                let gpp_sid = (data['applicableSections'] || []).join('_');
                let gpp = await optanonCMP.gpp.get();

                resolve({
                    gpp_sid,
                    gpp,
                });
            });
        });
    };

    return {
        getGPPData,
    };
}
